import React, { useState, useEffect } from "react";
import { useImpactReadOnly, openImpactBoxIfReadOnly } from "app/routes/psp/management/useImpactReadOnly";
import { useSelector } from "react-redux";
import IntlMessages, { IntlGetText } from "util/IntlMessages";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import PanhematinForm from "./Form";
import Table from "./Table";
import { callApiAsync, postCreateUpdatePanhematin, postDeletePanhematin } from "api/apiList";
import { BoolList, LesionSideList, justificationList } from "constants/Enums";
import { NotificationManager } from "react-notifications";
import DeletePanhematin from "./Delete";

const PanhematinDialog = ({ open, handleRequestClose, loadPanhematin, panhematinInfo }) => {
  const readOnlyImpactView = useImpactReadOnly();
  const { selectedPrescription } = useSelector(({ management }) => management);
  const [openCRU, setOpenCRU] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [currentRowObj, setCurrentRowObj] = useState(null);
  const msgSuccess = IntlGetText("core.SuccessSave");

  useEffect(() => {
      if (open) loadPanhematin();
    }, [open]);

  const handleCreateUpdate = async (data) => {
    await callApiAsync(
      () => postCreateUpdatePanhematin(data),
      () => {
        setOpenCRU(false);
        NotificationManager.success(msgSuccess);
        loadPanhematin();
      }
    );
  };

const handleDelete = async () => {
  await callApiAsync(
    () => postDeletePanhematin(currentRowObj.id),
    () => {
      setOpenDeleteDialog(false);
      NotificationManager.success(msgSuccess);
      loadPanhematin();
    }
  );
};

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      open={open}
      disableBackdropClick
      onClose={handleRequestClose}
    >
      <DialogTitle>
        <IntlMessages id="panhematin.cardTitle" />
      </DialogTitle>
      <DialogContent>
        <Table
          data={panhematinInfo}
          handleOpenCRU={() => setOpenCRU(true)}
          handleOpenDel={() => setOpenDeleteDialog(true)}
          setCurrentRowObj={setCurrentRowObj}
          panhematinInfo={panhematinInfo}
          showAddButton
          readOnly={readOnlyImpactView}
          justificationList={justificationList()}
        />
        <PanhematinForm
          rowObj={currentRowObj}
          prescriptionId={selectedPrescription?.id}
          openCRU={openCRU}
          handleRequestClose={() => setOpenCRU(false)}
          handleCreateUpdate={handleCreateUpdate}
          panhematinInfo={panhematinInfo}
          readOnly={readOnlyImpactView}
          boolList={BoolList()}
          lesionSideList={LesionSideList()}
          justificationList={justificationList()}
        />
        <DeletePanhematin
          open={openDeleteDialog}
          handleRequestClose={() => setOpenDeleteDialog(false)}
          handleDelete={handleDelete}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={handleRequestClose} color="secondary">
          <IntlMessages id="core.close" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PanhematinDialog;
